<!-- DetailMeter.vue - shows how many points the report earns so far and what would add more (Figma: Points and levels / Form) -->
<template>
  <section class="meter" aria-labelledby="meter-h">
    <div class="head">
      <h3 id="meter-h">{{ $t('report.submit.meter.title') }}</h3>
      <strong>{{ $t('report.submit.meter.points', { n: est.total, max }) }}</strong>
    </div>
    <div class="track" role="progressbar" :aria-valuenow="est.total" aria-valuemin="0" :aria-valuemax="max" :aria-label="$t('report.submit.meter.title')">
      <div class="fill" :style="{ width: Math.round((est.total / max) * 100) + '%' }"></div>
    </div>
    <ul class="chips">
      <li v-for="r in est.rows" :key="r.key" :class="{ done: r.done }">
        <span aria-hidden="true">{{ r.done ? '✓' : '+' }}</span> {{ $t('report.submit.meter.rows.' + r.key) }} +{{ r.points }}
      </li>
    </ul>
    <p class="note">{{ $t('report.submit.meter.note') }}</p>
  </section>
</template>

<script>
import { estimatePoints, MAX_REPORT_POINTS } from '@/utils/points';

export default {
  name: 'DetailMeter',
  props: { rating: Object, labels: Array, comment: String, ideas: { type: Number, default: 0 } },
  computed: {
    max() { return MAX_REPORT_POINTS; },
    est() { return estimatePoints({ rating: this.rating, labels: this.labels, comment: this.comment, ideas: this.ideas }); },
  },
};
</script>

<style scoped>
.meter { background: var(--color-surface); border: 1px solid var(--color-border); border-radius: var(--radius-lg); padding: 14px; display: flex; flex-direction: column; gap: 8px; text-align: start; }
.head { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
.head h3 { margin: 0; font-size: 15px; }
.head strong { color: var(--color-primary-text); font-size: 14px; }
.track { height: 12px; border-radius: 6px; background: var(--color-subtle); overflow: hidden; }
.fill { height: 100%; background: var(--color-primary); border-radius: 6px; transition: width 0.4s ease; }
.chips { list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: 6px; }
.chips li { font-size: 12px; padding: 4px 10px; border-radius: 999px; background: var(--color-subtle); }
.chips li.done { background: var(--color-primary); color: var(--color-on-primary); }
.note { margin: 0; font-size: 12px; color: var(--color-secondary); }
</style>
